const messages = {
	en: {
		noData: "No data to display",
	},
};

export default messages;
